function formData({form}) {
    const data = new FormData(form);
    return Object.fromEntries(data.entries());
}

function setButtonText({form, text}) {
    const element = form.querySelector('.payments-button-text');
    if (element) {
        element.textContent = text;
    }
}

// Show a spinner on form submission
function setLoading({form, isLoading}) {
    const submit = form.querySelector('input[type="submit"], button[type="submit"]');
    const spinner = form.querySelector('.payments-spinner');
    const text = form.querySelector('.payments-button-text');

    if (submit) {
        submit.disabled = isLoading;
        if (spinner) {
            if (isLoading) {
                if (submit.style.width) {
                    submit.dataset.paymentsWidth = submit.style.width;
                }
                submit.style.width = `${ submit.offsetWidth }px`;
            } else {
                delete submit.style.width;
                if (submit.dataset.paymentsWidth) {
                    submit.style.width = submit.dataset.paymentsWidth;
                    delete submit.dataset.paymentsWidth;
                }
            }
        }
    }

    if (spinner) {
        if (isLoading) {
            spinner.classList.remove('payments-hidden');
        } else {
            spinner.classList.add('payments-hidden');
        }
    }

    if (text) {
        if (isLoading) {
            text.classList.add('payments-hidden');
        } else {
            text.classList.remove('payments-hidden');
        }
    }
}

function showMessage( {form, message, auto = false} ) {
    if (Array.isArray( message )) {
        message = message.join( '<br/>');
    }

    let messageContainer = form.querySelector('.payments-message');
    if (!messageContainer) {
        messageContainer = document.createElement('p');
        messageContainer.classList.add('payments-message');
        form.insertBefore(messageContainer, form.firstChild);
    }
    messageContainer.classList.remove('payments-hidden');
    messageContainer.innerHTML = message;

    if (auto) {
        setTimeout(function () {
            messageContainer.classList.add('payments-hidden');
            messageContainer.textContent = '';
        }, 4000);
    }
}

function findParentElementByTag({element, tagName}) {
    tagName = tagName.toUpperCase();
    while (element) {
        if (element.tagName === tagName) {
            return element;
        }
        element = element.parentElement;
    }
    return null;
}

/**
 * @param props {Object}
 * @param props.className {string}
 * @param props.parent {Element}
 */
function removeElementsByClass({className, parent = document}) {
    const elements = parent.getElementsByClassName(className);
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }
}

/**
 * @param props {Object}
 * @param props.parent {Element}
 */
function clearFieldErrors({parent = document}) {
    removeElementsByClass({className: 'payments-field-error', parent});
}

function setFieldError({input, message}) {
    const element = document.createElement('p');
    element.classList.add('payments-error');
    element.classList.add('payments-field-error');
    element.textContent = message;
    input.after(element);
}

function clearURLQueryString({url}) {
    url = new URL(window.location.href);
    for (const key of Array.from(url.searchParams.keys())) {
        url.searchParams.delete(key);
    }
    return url;
}

// Guess the appearance.
function stripeAppearance({form}) {
    let style = getComputedStyle(form);
    const variables = {
        fontSizeBase: style.fontSize,
        colorBackground: style.backgroundColor,
        colorText: style.color,
        fontFamily: style.fontFamily,
    };

    const input = form.querySelector( 'input[type="text"],input[type="email"]');
    if (input) {
        style = getComputedStyle(input);
        variables.borderRadius = style.borderRadius ? style.borderRadius : '0px';
    }

    // noinspection JSUnresolvedVariable

    const appearance = window.pay.stripe_appearance ? JSON.parse(window.pay.stripe_appearance) : {};
    return Object.assign({variables}, appearance);
}

function displayAll(selector, value = 'block') {
    document.querySelectorAll(selector).forEach(function(node) {
        node.style.display = value;
    });
}

function addClassAll(selector, className) {
    document.querySelectorAll(selector).forEach(function(node) {
        node.classList.add(className);
    });
}

function removeClassAll(selector, className) {
    document.querySelectorAll(selector).forEach(function(node) {
        node.classList.remove(className);
    });
}

/**
 * @param error {unknown}
 */
function getErrorMessage(error) {
    if (error instanceof Error) return error.message;
    return String(error);
}

// noinspection JSUnusedGlobalSymbols
module.exports = {
    setButtonText,
    setFieldError,
    clearFieldErrors,
    setLoading,
    formData,
    findParentElementByTag,
    removeElementsByClass,
    showMessage,
    clearURLQueryString,
    stripeAppearance,
    getErrorMessage,
    displayAll,
    addClassAll,
    removeClassAll,
};
